<template>
  <v-card
    class="ma-0 py-2 px-4 pt-4"
    style="background: #F5F5F5"
    outlined
    tile
  >
    <validation-observer ref="validator" v-slot="{ handleSubmit }">
      <div class="py-2 mb-3 d-flex justify-space-between">
        <div class="font-weight-bold">THANH TOÁN NHIỀU LẦN</div>
        <span class="close-btn cursor-pointer" @click="close()">
          <v-icon color="#9e9e9e">
            mdi-close
          </v-icon>
        </span>
      </div>
      <div  class="py-1 d-flex justify-space-between">
        <div
          class="d-flex justify-space-between"
          style="width: 370px"
        >
          <span class="text-uppercase my-auto">• Số tiền còn lại cần thanh toán:</span>
          <span
            class="my-auto"
            >{{
              detailOrder.totalPrice
                ? formatCurrencyNoD(
                    detailOrder.totalPrice - detailOrder.paidAmount
                  )
                : "--"
            }}
            (đ)</span
          >
        </div>
        <div style="background-color: #0075FF33;border-radius:4px;" class="px-3 py-1">
          <v-icon style="color:#0075FF">mdi-information-slab-circle-outline</v-icon>
          <span style="color:#555555;font-style: italic;" class="mx-1">Hoàn tất thanh toán đơn hàng sẽ tự động mở khóa toàn bộ hạn học, bao gồm hạn học gốc và cả ưu đãi, khuyến mại</span>
        </div>
      </div>
      <div class="d-flex">
        <div>
          <div
            v-for="(item, index) in listHistoryPay"
            :key="'pay' + index"
            class="py-1 mt-2 d-flex justify-space-between"
            style="width: 370px"
          >
            <span class="text-uppercase"
              >• Số tiền thanh toán lần {{ index + 1 }}:</span
            >
            <span>{{ formatCurrencyNoD(item.amount) }} (đ)</span>
          </div>
          <div class="py-1 text-uppercase d-flex justify-space-between">
            <span style="margin-top: 10px"
              >• Số tiền thanh toán lần
              {{
                listHistoryPay && listHistoryPay.length
                  ? listHistoryPay.length + 1
                  : 1
              }}
              <span style="color: red">*</span>:</span
            >
            <span v-if="!selectComplete">
              <validation-provider
                v-slot="{ errors }"
                :name="`Số tiền cần thanh toán`"
                :rules="{
                  min_value: 0,
                  max_value: detailOrder.remainsUnpaidAmount,
                  required: true,
                  numeric: true,
                }"
              >
                <v-text-field
                  :error-messages="errors"
                  dense
                  type="number"
                  class="custome-pay"
                  :placeholder="`Nhập số tiền`"
                  v-model="payTurnTwo"
                ></v-text-field>
              </validation-provider>
            </span>
            <span v-else style="border-bottom: 1px dotted #ccc;text-align: end; width: 36%; text-transform: lowercase;margin: auto 0">{{formatCurrencyNoD(payTurnTwo)}} (đ)</span>
          </div>
        </div>
        <div class="mx-12" style="width: calc(100% - 400px);">
          <div
            class="py-1 mt-2 d-flex justify-space-between"
            v-for="(item, index) in listHistoryPay"
            :key="'status' + index"
          >
            <div class="mr-12">
              <div
                class="d-flex justify-space-between"
                :style="{width: getPaymentMethod(item.paymentMethod) === 'Biên nhận' ? '280px': '250px'}"
              >
                <span class="text-uppercase">• Phương thức thanh toán:</span>
                <span
                  >
                {{getPaymentMethod(item.paymentMethod)}}</span
                >
              </div>

            </div>
            <div v-if="checkSTATUS_PAY(item.status)" class="ml-12 px-8">• Trạng thái: {{ checkSTATUS_PAY(item.status).value }}</div>
          </div>
          <div class="py-1 d-flex justify-space-between">
            <div class="d-flex justify-space-between">
              <span style="margin-top: 10px" class="text-uppercase">• Phương thức thanh toán:</span>
              <v-select
                :items="paymentTypes"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn "
                label=""
                attach
                dense
                outlined
                height="30"
                v-model="paymentType"
                style="flex:none;width: 195px !important;"
                class="customer-pay-select short-w mx-3"
                :menu-props="{ top: true, offsetY: true, maxHeight: '200' }"
              ></v-select>
            </div>
            <v-checkbox
              v-model="selectComplete"
              color="#0075FF"
              style="margin: 0; width:190px;"
              hide-details
            >
              <template v-slot:label>
                <div>
                  <span style="color:#0075FF" class="font-weight-bold">Hoàn tất ngay</span>
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
      <div class="px-4 py-2 d-flex justify-space-between" style="background-color: #DDDDDD;border-radius: 8px">
        <div style="color:#002E86">TỔNG TIỀN ĐÃ THANH TOÁN: <span>{{formatCurrencyNoD(detailOrder.paidAmount)}} đ</span></div>
        <div style="color:#AC0606">TỔNG TIỀN ĐÃ QUY ĐỔI: <span>{{formatCurrencyNoD(detailOrder.totalTrialMoney)}} đ</span></div>
        <div style="color:#279600">TỔNG TIỀN CÓ THỂ QUY ĐỔI:
          <span>
            {{formatCurrencyNoD(parseInt(payTurnTwo ? payTurnTwo : 0)
              + parseInt(detailOrder && detailOrder.unusedReceiptAmount ? detailOrder.unusedReceiptAmount : 0)) }} đ
          </span>
        </div>
      </div>
      <v-row
        v-if="
          detailOrder.orderTrialProducts &&
          detailOrder.orderTrialProducts.length
          && !loading
        "
      >
        <v-col class="py-3" cols="12">
          <v-simple-table
            class="table-layout table-products-pay"
            style="background: transparent"
            id="style-2" fixed-header
          >
            <thead>
              <tr>
                <th class="col-program-name text-left" style="background: #f5f5f5;">Gói học thử</th>
                <th class="col-expired text-left" style="background: #f5f5f5;">Tên con</th>
                <th class="col-expired text-left" style="width: 180px;background: #f5f5f5;">
                  Thời hạn
                </th>
                <th class="col-exchange text-left" style="width: 220px;background: #f5f5f5;">
                  Thời hạn đã quy đổi
                </th>
                <th class="col-total-exchange text-left" style="width: 220px;background: #f5f5f5;">
                  Nhập thời hạn muốn quy đổi
                </th>
                <th class="col-total-money text-left" style="width: 180px;background: #f5f5f5;">
                  Thành tiền
                </th>
              </tr>
            </thead>
            <tbody v-if="!loading">
              <template v-for="(item, index) in detailOrder.orderTrialProducts">
                <tr :key="index" v-if="item.productType !== 'sku_combo'">
                  <td class="text-left">
                    <div>{{ findSkuProduct(item).name }}</div>
                    <div style="color: #b70727;font-size:12px">{{item.notFindTrial ? 'Không có gói 1 buổi tương ứng để quy đổi.': ''}}</div>
                  </td>
                  <td class="text-left"> {{showChildName(item)}}</td>
                  <td>
                    <div class="d-flex pb-2">
                      <div class="string-form">
                        {{ (findSkuProduct(item).numOfLesson * handleTimebyQuanity(item, 'tutor') || findSkuProduct(item).duration) }}
                      </div>
                      <div class="mx-1">
                        {{
                          item.productType === "sku_tutor"
                            ? "(Buổi)"
                            : "(Tháng)"
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex pb-2">
                      <div class="string-form">{{ item.totalTrailLessons }}</div>
                      <div class="mx-1">
                        {{
                          item.productType === "sku_tutor"
                            ? "(Buổi)"
                            : "(Tháng)"
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <template v-if="item.isTransfered">
                     <div class="d-flex" style="justify-content: space-between;column-gap: 10px">
                       <div style="color: red; font-style: italic;text-align: left !important;">Đã chuyển đổi</div>
                       <div style="" class="mx-1">
                         {{
                           item.productType === "sku_tutor"
                               ? "(Buổi)"
                               : "(Tháng)"
                         }}
                       </div>
                     </div>
                    </template>
                    <div v-else class="d-flex">
                      <validation-provider
                        v-slot="{ errors }"
                        :name="`Thời hạn muốn quy đổi ${index}`"
                        :rules="{
                          min_value: 0,
                          max_value:
                            ((findSkuProduct(item).numOfLesson * handleTimebyQuanity(item, 'tutor')) || findSkuProduct(item).duration) -
                            item.totalTrailLessons,
                          required: true,
                          numeric: true,
                        }"
                      >
                        <v-text-field
                          label=""
                          :error-messages="errors"
                          dense
                          placeholder="Nhập thời hạn muốn quy đổi"
                          type="number"
                          class="custome-time-sku"
                          v-model="item.trailLessons"
                          @change="keyRender++"
                          :disabled="checkInput(item) || selectComplete"
                        ></v-text-field>
                      </validation-provider>
                      <v-tooltip right v-if="showWaring(item)">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" style="cursor: pointer;color:#FF7A00" class="mb-2">mdi-information-slab-circle</v-icon>
                          </template>
                          <span>Nhập {{((findSkuProduct(item).numOfLesson * handleTimebyQuanity(item, 'tutor')) || findSkuProduct(item).duration) - item.totalTrailLessons}} để hoàn thành quy đổi toàn bộ hạn học</span>
                      </v-tooltip>
                      <div style="margin-top: 10px" class="mx-1">
                        {{
                          item.productType === "sku_tutor"
                            ? "(Buổi)"
                            : "(Tháng)"
                        }}
                      </div>
                    </div>
                  </td>
                  <td class="text-left">
                    <span v-if="selectComplete || item.isTransfered">--</span>
                    <div v-else class="d-flex pb-2">
                      <div class="string-form">
                        <span 
                          v-if="Number(item.trailLessons) == (((findSkuProduct(item).numOfLesson * handleTimebyQuanity(item, 'tutor')) || findSkuProduct(item).duration) - item.totalTrailLessons)"
                          style="color: #0075FF"
                        >
                          {{formatCurrencyNoD(countPreMoneyComplete(item))}}
                        </span>
                        <span v-else :style="{color:showWaring(item) ? '#FF7A00' : '#555555' }"> {{ countPreMoney(item) }}</span>
                        <v-tooltip bottom v-if="showWaring(item)">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" style="cursor: pointer;color:#FF7A00" class="mb-1">mdi-alert-circle</v-icon>
                          </template>
                          <span>Số tiền quy đổi đã lớn hơn giá trị sản phẩm gốc. Hãy quy đổi toàn bộ hạn học để tối ưu chi phí.</span>
                        </v-tooltip>
                      </div>
                      <div class="mx-1">(đ)</div>
                    </div>
                  </td>
                </tr>
                <template v-if="item.productType === 'sku_combo'">
                  <tr :key="'combo'+index">
                    <td class="text-left">{{item.productName}}</td>
                    <td class="text-left"> {{showChildName(item)}}</td>
                    <td class="text-left">--</td>
                    <td class="text-left">--</td>
                    <td class="text-left">
                      <template v-if="item.isTransfered">
                        <div style="color: red; font-style: italic;text-align: left !important;">Đã chuyển đổi</div>
                      </template>
                      <template v-else>--</template>
                    </td>
                    <td class="text-left">
                      <template v-if="item.isTransfered">--</template>
                      <div  v-else class="d-flex">
                        <div class="string-form">
                          <span v-if="completeCombo(item)" style="color:#0075FF">
                            {{formatCurrencyNoD(totalComboByItem(item))}}
                          </span>
                          <span v-else :style="{color: (totalComboByItem(item) > Number(findComboByItem(item).intoMoney)) ? '#FF7A00' : '#555555'}">
                            {{formatCurrencyNoD(totalComboByItem(item))}}
                          </span> 
                          <v-tooltip bottom v-if="totalComboByItem(item) > Number(findComboByItem(item).intoMoney)">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" style="cursor: pointer;color:#FF7A00" class="mb-1">mdi-alert-circle</v-icon>
                            </template>
                            <span>Số tiền quy đổi đã lớn hơn giá trị sản phẩm gốc. Hãy quy đổi toàn bộ hạn học để tối ưu chi phí.</span>
                          </v-tooltip>
                        </div> 
                        <span class="mx-1">(đ)</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-for="duo in item.skuDuos" :key="'duoSku' + duo.name">
                    <td class="text-left">
                      <span class="pl-2">● <span class="mx-2">{{ duo.name }}</span></span>
                    </td>
                    <td class="text-left">--</td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          {{ duo.duration }}
                        </div>
                        <div class="mx-1">
                          (Tháng)
                        </div>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex">
                        <div class="string-form">{{ duo.totalTrailLessons }}</div> 
                        <span>(Tháng)</span>
                      </div>
                    </td>
                    <td>
                      <template v-if="item.isTransfered">
                        <div class="text-left">--</div>
                      </template>
                      <template v-else>
                        <div class="d-flex">
                          <validation-provider
                              v-slot="{ errors }"
                              :name="`Thời hạn muốn quy đổi ${duo.name}`"
                              :rules="{ min_value: 0, max_value: (parseInt(duo.duration) - duo.totalTrailLessons), required: true, numeric: true }"
                          >
                            <v-text-field
                                label=""
                                :error-messages="errors"
                                placeholder="Nhập thời hạn muốn quy đổi"
                                dense
                                :disabled="!payTurnTwo || duo.isError || selectComplete"
                                type="number"
                                v-model="duo.trailLessons"
                            ></v-text-field>
                          </validation-provider>
                          <div class="pt-3 pl-2">
                            (Tháng)
                          </div>
                        </div>
                      </template>
                    </td>
                    <td class="text-left">
                      <span v-if="selectComplete || item.isTransfered ">--</span>
                      <div  v-else class="d-flex pb-2">
                        <div class="string-form">
                          <span v-if="completeCombo(item)">--</span>
                          <span v-else>{{ duo.orgPrice ? formatCurrencyNoD(Math.ceil(duo.orgPrice/duo.duration*1.5) * Number(duo.trailLessons)) : '0' }}</span>
                        </div>
                        <div class="mx-1">(đ)</div>
                      </div>
                    </td>
                  </tr>
                  <tr v-for="tutor in item.skuTutors" :key="'tutorSku' + tutor.name">
                    <td class="text-left">
                      <span class="pl-2">● <span class="mx-2">{{ tutor.name }}</span></span>
                    </td>
                    <td class="text-left">--</td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          {{ tutor.package.split('-')[1] * handleTimebyQuanity(item, 'combo') * Number(tutor.comboDetail && tutor.comboDetail.itemQuantity ? tutor.comboDetail.itemQuantity : 1) }}
                        </div>
                        <div class="mx-1">
                          (Buổi)
                        </div>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex">
                        <div class="string-form">{{ tutor.totalTrailLessons }}</div>
                        <span>(Buổi)</span>
                      </div>
                    </td>
                    <td>
                      <div v-if="item.isTransfered" class="text-left">--</div>
                      <div  v-else class="d-flex">
                        <validation-provider
                          v-slot="{ errors }"
                          :name="`Thời hạn muốn quy đổi ${tutor.name}`"
                          :rules="{
                            min_value: 0,
                            max_value: ((parseInt(tutor.package.split('-')[1]) * handleTimebyQuanity(item, 'combo') * Number(tutor.comboDetail && tutor.comboDetail.itemQuantity ? tutor.comboDetail.itemQuantity : 1))-tutor.totalTrailLessons),
                            required: true,
                            numeric: true,
                          }"
                        >
                          <v-text-field
                            label=""
                            :error-messages="errors"
                            placeholder="Nhập thời hạn muốn quy đổi"
                            dense
                            :disabled="!payTurnTwo || tutor.isError || selectComplete"
                            type="number"
                            v-model="tutor.trailLessons"
                          ></v-text-field>
                        </validation-provider>
                        <div class="pt-3 pl-2">
                          (Buổi)
                        </div>
                    </div>
                    </td>
                    <td class="text-left">
                      <span v-if="selectComplete || item.isTransfered ">--</span>
                      <div  v-else class="d-flex pb-2">
                        <div class="string-form">
                          <span v-if="completeCombo(item)">--</span>
                          <span v-else>{{ (tutor.orgPrice && tutor.skuTutorPaymentUnit) ? formatCurrencyNoD(tutor.skuTutorPaymentUnit.orgPrice * Number(tutor.trailLessons)) : '0' }}</span> 
                        </div>
                        <div class="mx-1">(đ)</div>
                      </div>
                    </td>
                  </tr>
                </template> 
              </template>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col :key="keyRender">
          <div class="font-weight-bold text-end mr-12">
            • Tổng tiền quy đổi lần này: 
            <span v-if="selectComplete">{{formatCurrencyNoD(payTurnTwo)}}</span>
            <span v-else>{{ totalMoney() ? formatCurrencyNoD(totalMoney()) : 0 }}</span> (đ)
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <v-btn
            class="btn-success"
            @click.prevent="handleSubmit(createOrder)"
            color="#35b707"
            height="38"
            width="100"
            :disabled="isDisableCreate"
          >
            <span>Tiếp tục</span>
          </v-btn>
          <v-btn
            class="btn-cancel"
            color="#b70727"
            height="38"
            width="100"
            @click="close()"
          >
            Hủy
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-card>
</template>

<script>
import { STATUS_PAY } from "@/helpers/constants";
import { showChildName_C, formatCurrencyNoD_C }  from "../HelperFunc";
import RepositoryFactory from "@/repositories/RepositoryFactory";
const OrderRepository = RepositoryFactory.get("order");

export default {
  props: {
    detailOrder: {
      type: Object,
      default: () => {},
    },
    timelineEvents: {
      type: Array,
      default: () => [],
    },
    skuTutors: {
      type: Array,
      default: () => [],
    },
    skuDuos: {
      type: Array,
      default: () => [],
    },
    skuCombos: {
      type: Array,
      default: () => [],
    },
    childs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      STATUS_PAY,
      payTurnTwo: null,
      paymentTypes: [
        {
          id: "COD",
          name: "COD",
        },
        {
          id: "BANK",
          name: "BANK",
        },
      ],
      paymentType: "COD",
      trailLessons: 1,
      loading: true,
      keyRender: 0,
      selectComplete: false,
    };
  },
  computed: {
    isDisableCreate() {
      const paymentMethod = this.paymentTypes.find(item => item.id === this.paymentType);
      if(paymentMethod &&  paymentMethod.amountRemaining && this.payTurnTwo &&  parseFloat(this.payTurnTwo) > 0) {
        const totalReceipt = paymentMethod && paymentMethod.amountRemaining ? paymentMethod.amountRemaining : 0;
        console.log(this.payTurnTwo, 'this.payTurnTwo')
        console.log(totalReceipt, 'totalReceipt')
        return parseFloat(this.payTurnTwo) > parseFloat(totalReceipt);
      }
      return false;
    },
    listHistoryPay() {
      const listHistory = this.timelineEvents.filter(item => item.objectType === 'order_receipt');
      const data = _.cloneDeep(listHistory);
      console.log(data.reverse(), 'data.reverse();')
      return data.reverse();
    },
  },
  watch: {
    selectComplete(val) {
      if (val) {
        this.payTurnTwo = this.detailOrder && this.detailOrder.remainsUnpaidAmount ? this.detailOrder.remainsUnpaidAmount : 0;
        this.detailOrder.orderTrialProducts.map((item) => {
          if ( item.productType !== 'sku_combo' ) {
            item.trailLessons = item.productType === 'sku_tutor' ? ((this.findSkuProduct(item).numOfLesson* this.handleTimebyQuanity(item, 'tutor')) - item.totalTrailLessons) : (this.findSkuProduct(item).duration - item.totalTrailLessons);
          } else {
            item.skuDuos.map((duo) => {
              duo.trailLessons = duo.duration - duo.totalTrailLessons;
            });
            item.skuTutors.map((tutor) => {
              tutor.trailLessons = (tutor.package.split('-')[1] * this.handleTimebyQuanity(item, 'combo') * Number(tutor.comboDetail && tutor.comboDetail.itemQuantity ? tutor.comboDetail.itemQuantity : 1)) - tutor.totalTrailLessons;
            });
          }
        })
      } else {
        this.payTurnTwo = null;
        this.detailOrder.orderTrialProducts.map((item) => {
          if ( item.productType !== 'sku_combo' ) {
            item.trailLessons = null;
          } else {
            item.skuDuos.map((duo) => {
              duo.trailLessons = null;
            });
            item.skuTutors.map((tutor) => {
              tutor.trailLessons = null;
            });
          }
        })
      }
    },
    payTurnTwo(val) {
      if(!val || Number(val) === 0) {
        this.detailOrder.orderTrialProducts.map((item) => {
          if ( item.productType !== 'sku_combo' ) {
            item.trailLessons = null;
          } else {
            item.skuDuos.map((duo) => {
              duo.trailLessons = null;
            });
            item.skuTutors.map((tutor) => {
              tutor.trailLessons = null;
            });
          }
        })
      }
    }
  },
  mounted() {
    this.callApiPaymentMethod();
    this.loading = true;
    this.detailOrder.orderTrialProducts.forEach(async (item, index) => {
      await this.getBaseSku(item);
      if (index === this.detailOrder.orderTrialProducts.length - 1) this.loading = false;
    });
  },
  methods: {
    getPaymentMethod(data) {
      const paymentReceipt = this.paymentTypes.find(item => item.id == data);
      if((paymentReceipt && paymentReceipt.value ) || data === 'MONEY_RECEIPT') {
        return  'Biên nhận';
      }else {
        return data;
      }
    },
    async callApiPaymentMethod() {
      try{
        const response = await OrderRepository.getPaymentMethodApi(parseInt(this.$route.params.id));
        if(response.success) {
          const optionReceipt = this.paymentTypes.find(item => item.id == 'MONEY_RECEIPT');
          if(!optionReceipt && response.data.length > 0) {
            const newPaymentTypes = response.data.map(item => ({
              id: `MONEY_RECEIPT-${item.id}`,
              name: `Biên nhận${item.amountRemaining ? ' - ' + formatCurrencyNoD_C(item.amountRemaining) : ''}`,
              value: item.id,
              amountRemaining: item.amountRemaining ? item.amountRemaining : 0
            }));
            this.paymentTypes.push(...newPaymentTypes);
          }
        }
      }catch (e) {
        console.log(e)
      }
    },
    showWaring(item) {
      if (Number(item.trailLessons) + Number(item.totalTrailLessons) === ((this.findSkuProduct(item).numOfLesson * this.handleTimebyQuanity(item, 'tutor')) || this.findSkuProduct(item).duration)) {
        return false
      }
      if ((Number(item.trailLessons) + Number(item.totalTrailLessons))*(item.productType == 'sku_tutor' ? item.baseOrgPrice : Math.ceil(item.baseOrgPrice/item.duration*1.5)) > (this.findSkuProduct(item).orgPrice)) {
        return true
      }
      return false
    },
    findComboByItem(item) {
      const data = this.detailOrder.combos.find(cb => cb.comboId == item.comboId)
      return data
    },
    completeCombo(current) {
      let duosComplete = 0;
      let tutorsComplete = 0;
      current.skuDuos.forEach((item) => {
        if (Number(item.trailLessons) + Number(item.totalTrailLessons) == item.duration) {
          duosComplete += 1
        }
      });
      current.skuTutors.forEach((item) => {
        if ((Number(item.trailLessons) + Number(item.totalTrailLessons)) == (item.numOfLesson * item.comboDetail.itemQuantity * this.findComboByItem(current).quantity)) {
          tutorsComplete += 1;
        }
      });
      if (duosComplete === current.skuDuos.length && tutorsComplete === current.skuTutors.length) {
        return true
      }
      return false
    },
    async createOrder() {
      if ((Number(this.totalMoney()) > (Number(this.detailOrder.paidAmount) - Number(this.detailOrder.totalTrialMoney) +  Number(this.payTurnTwo))) && !this.selectComplete) {
        return this.$swal({
          title: "Thông báo",
          text: "Vượt quá số tiền có thể quy dổi.",
          icon: "error",
          timer: 2000,
        });
      }
      let trailProduct = [];
      if (this.detailOrder && this.detailOrder.orderTrialProducts) {
        const data = _.cloneDeep(this.detailOrder.orderTrialProducts);
        data.forEach((item) => {
          if (item.productType !== "sku_combo") {
            trailProduct.push({
              trailLessons: !item.isTransfered ? item.trailLessons : 0,
              productId: item.productId,
              productType: item.productType,
              money: !item.isTransfered ? item.trailLessons * (item.productType == 'sku_tutor' ? item.baseOrgPrice : Math.ceil(item.baseOrgPrice/this.findSkuProduct(item).duration*1.5)) : 0,
              customerId: item.customerId,
              numberOfSection: this.findSkuProduct(item).numOfLesson || this.findSkuProduct(item).duration,
              orderProductId: item.orderProductId,
            });
          }
          if (item.productType === "sku_combo") {
            item.skuDuos.forEach((comboItem) => {
              trailProduct.push({
                trailLessons: !item.isTransfered ? comboItem.trailLessons : 0, // thời hạn học thử
                productId: comboItem.id, // id sản phầm
                productType: 'sku_duo', 
                money: !item.isTransfered ? comboItem.trailLessons * Math.ceil(comboItem.orgPrice/comboItem.duration*1.5) : 0, // thành tiền
                customerId: item.customerId,
                numberOfSection: comboItem.duration, // thời hạn gốc của sku
                comboId: item.productId,
                orderProductId: comboItem.orderProductId,

              });
            });
            item.skuTutors.forEach((comboItem) => {
              trailProduct.push({
                trailLessons: !item.isTransfered ? comboItem.trailLessons : 0, // thời hạn học thử
                productId: comboItem.id, // id sản phầm
                productType: 'sku_tutor', 
                money: !item.isTransfered ? comboItem.trailLessons * (comboItem.skuTutorPaymentUnit ? comboItem.skuTutorPaymentUnit.orgPrice : 0) : 0, // thành tiền
                customerId: item.customerId,
                numberOfSection: comboItem.package.split('-')[1], // thời hạn gốc của sku
                comboId: item.productId,
                orderProductId: comboItem.orderProductId,
              });
            });
          }
        });
      }
      const paymentReceipt = this.paymentTypes.find(item => item.id === this.paymentType);
      const body = {
        orderId: this.$route.query.order,
        shippingAddress: {
          receiver: this.detailOrder.receiver,
          phone: this.detailOrder.phone,
          email: this.detailOrder.email,
          tinhId: this.detailOrder.tinhId,
          huyenId: this.detailOrder.huyenId,
          xaId: this.detailOrder.xaId,
          detailAddress: this.detailOrder.detailAddress,
        },
        orderReceipt: {
          amount: this.payTurnTwo,
          paymentMethod: this.paymentType,
        },
        trailProduct: trailProduct.length ? trailProduct : null,
      };
      if(paymentReceipt && paymentReceipt.value) {
        body.orderReceipt.paymentMethod = 'MONEY_RECEIPT';
        body.paymentReceiptId = paymentReceipt.value;
      }
      const totalAmount = this.detailOrder.totalPrice - this.detailOrder.paidAmount
      // REMOVE
      const data = {
        body,
        totalAmount,
      }
      return this.$emit("closeDialog", data);
    },
    formatCurrencyNoD(val) {
      return formatCurrencyNoD_C(val);
    },
    checkSTATUS_PAY(status) {
      return this.STATUS_PAY.find((item) => item.key === status);
    },
    findSkuProduct(product) {
      if (product.productType === "sku_tutor") {
        return this.skuTutors.find((item) => item.id === product.productId);
      }
      if (product.productType === "sku_duo") {
          return this.skuDuos.find((item) => item.id === product.productId);
      }
      // if (product.productType === "Combo") {
      //     return this.skuCombos.find((item) => item.id === product.skuId);
      // }
    },
    async getBaseSku(product) {
      const type = product.productType.split("_")[1];
      if (type !== "combo") {
        const params = {
          product_type: type,
          include_price_policy: 1,
          transaction_status: product.productType == 'sku_duo' ? null : "selling",
          status: product.productType == 'sku_duo'? null : "active",
          num_of_lesson: 1,
          product_id: product.productType !== 'sku_duo' ? this.findSkuProduct(product).productId : null,
          curriculum_id: this.findSkuProduct(product).curriculumId,
          teacher_type_ids: this.findSkuProduct(product).teacherTypeId,
          class_type_ids: this.findSkuProduct(product).classTypeId,
          is_from_crm: 1,
          sku_ids: product.productType == 'sku_duo' ? [product.productId] : null,
        };
        const res = await OrderRepository.advanceSearchForCombo(params);
        product.baseOrgPrice = 0;
        product.trailLessons = null;
        if (res && res.data && res.data.length) {
          product.baseOrgPrice = res.data[0].orgPrice;
          if (type === "duo") {
            product.duration = res.data[0].duration;
          }
        } else {
          product.notFindTrial = true;
        }
      }
      if (type === "combo") {
        const params = {
          product_type: type,
          include_price_policy: 1,
          // transaction_status: "selling",
          // status: "active",
          num_of_lesson: 1,
          include_sku_tutor_payment_unit: 1,
          is_from_crm: 1,
          sku_ids: [product.productId],
        };
        const res = await OrderRepository.advanceSearchForCombo(params);
        if (res && res.data && res.data.length) {
          product.productName = res.data[0].name;
          product.skuTutors = res.data[0].skuTutors.map((item) => {
            return {
              ...item,
              isTransfered: product.isTransfered ? product.isTransfered : false,
              totalTrailLessons: product.items.find((i) => i.productId === item.id).totalTrailLessons,
              trailLessons: null,
              package: `${item.classTypeId}-${item.numOfLesson}`,
              orderProductId: product.items.find((i) => i.productId === item.id).orderProductId,
            };
          });
          product['skuDuos'] = res.data[0].skuDuos.map((item) => {
            if (!product.items || !Array.isArray(product.items)) {
              return {
                ...item,
                trailLessons: null,
                totalTrailLessons: 0,
                orderProductId: null
              };
            }
            const matchingItem = product.items.find((i) => i.productId === item.id);
            if (!matchingItem) {
              return {
                ...item,
                trailLessons: null,
                totalTrailLessons: 0,
                orderProductId: null
              };
            }
            return {
              ...item,
              isTransfered: product.isTransfered ? product.isTransfered : false,
              trailLessons: null,
              totalTrailLessons: matchingItem.totalTrailLessons,
              orderProductId: matchingItem.orderProductId,
            };
          });
        } else {
          product.notFindTrial = true;
        }

      }
    },
    countPreMoney(item) {
      let total = 0
      if (item.productType === 'sku_duo') {
        total = Math.ceil(item.baseOrgPrice/this.findSkuProduct(item).duration*1.5) * item.trailLessons
      } else {
        total = Number(item.trailLessons) * Number(item.baseOrgPrice);
      }
      return total ? this.formatCurrencyNoD(total) : 0;
    },
    countPreMoneyComplete(item) {
      let total = 0
      const product = this.detailOrder.orderProducts.find((product) => product.productId === item.productId && product.customerId === item.customerId);
      if (item.productType === 'sku_duo') {
        total = product.intoMoney - (Number(item.totalTrailLessons) * Math.ceil(item.baseOrgPrice/this.findSkuProduct(item).duration*1.5));
      } else {
        total = product.intoMoney - (Number(item.totalTrailLessons) * Number(item.baseOrgPrice));
      }
      return total > 0 ? Number(total) : 0;
    },
    checkInput(item) {
      if (item.notFindTrial) return true;
      if (this.payTurnTwo) return false;
      return true;
    },
    totalComboByItem(current) {
      let duosComplete = 0;
      let tutorsComplete = 0;
      let cachedPriceDuo = 0;
      let cachedPriceTutor = 0;

      const calculateDuoTotal = current.skuDuos.reduce((acc, item) => {
        const itemTotal = Math.ceil(item.orgPrice / item.duration * 1.5) * Number(item.trailLessons);
        if (Number(item.trailLessons) + Number(item.totalTrailLessons) === item.duration) {
          duosComplete += 1;
          cachedPriceDuo += Math.ceil(item.orgPrice / item.duration * 1.5) * Number(item.totalTrailLessons);
        }
        return acc + itemTotal;
      }, 0);

      const calculateTutorTotal = current.skuTutors.reduce((acc, item) => {
        const itemTotal = (item.skuTutorPaymentUnit ? item.skuTutorPaymentUnit.orgPrice : 0) * Number(item.trailLessons);
        if ((Number(item.trailLessons) + Number(item.totalTrailLessons)) === 
          (item.numOfLesson * item.comboDetail.itemQuantity * this.findComboByItem(current).quantity)) {
          tutorsComplete += 1;
          cachedPriceTutor += (item.skuTutorPaymentUnit ? item.skuTutorPaymentUnit.orgPrice : 0) * Number(item.totalTrailLessons);
        }
        return acc + itemTotal;
      }, 0);

      if (duosComplete === current.skuDuos.length && tutorsComplete === current.skuTutors.length) {
        return this.findComboByItem(current).intoMoney - Number(cachedPriceDuo + cachedPriceTutor);
      }
      return Number(calculateDuoTotal + calculateTutorTotal);
    },
    totalMoney() {
      let total = 0;
      this.detailOrder.orderTrialProducts.forEach((current)=> {
        if (current.productType == 'sku_combo') {
          total += this.totalComboByItem(current);
        } else {
          if (Number(current.trailLessons) == ((this.findSkuProduct(current).numOfLesson * this.handleTimebyQuanity(current, 'tutor') || this.findSkuProduct(current).duration)-current.totalTrailLessons)) {
            total += this.countPreMoneyComplete(current);
          } else {
            total += current.productType == 'sku_tutor' ? (current.baseOrgPrice * Number(current.trailLessons)) : (Math.ceil(current.baseOrgPrice/current.duration*1.5) * Number(current.trailLessons));
          }
        }
      })
      return total;
    },
    handleTimebyQuanity(item, type) {
      if (type === "combo") {
      const comboData = this.detailOrder.combos.find((combo) => combo.productId === item.productId);
      return comboData ? comboData.quantity : 0;
      }
      const productData = this.detailOrder.orderProducts.find((product) => product.productId === item.productId);
      return productData ? productData.quantity : 0;
    },
    close() {
      this.$emit('close');
    },
    showChildName(item) {
      return showChildName_C(this.childs, item);
    },
  },
};
</script>
